// Context: some domains don't allow the terms "SEL" / "Social Emotional Learning" in their schools
// These domains are identified by belonging to specific content profiles
// This mixin provides utilities to prevent those terms from being displayed to users in those content profiles

import { mapGetters } from 'vuex'
import { CONTENT_TYPES } from '@/util/access_visibility'
import { getAreasOfNeed } from '@/api/presentlevels'
import {
  AssessmentFilterOption,
  assessmentsFilterOptions,
} from '@/components/search/assessments/assessments_filter_options'

export { noSelMixin }

export const SEL_DEFAULT_SUBJECT_STRATEGIES_GOALS='Behavior & SEL'
export const SEL_DEFAULT_AREA_PLW='Social & Emotional Learning'

export const SEL_REPLACEMENT_STRATEGIES_PLW='Social Skills'

export const SEL_REPLACEMENT_RESOURCES='Behavior & Social Skills'

const SEL_REPLACEMENT_BEHAVIOR_SKILLS = 'Behavior Skills'
const SEL_REPLACEMENT_RESILIENCY_SKILLS = 'Resiliency Skills'
const SEL_REPLACEMENT_SOCIAL_SKILLS_INSTRUCTION = 'Social Skills Instruction'

const selReplacementSubjects = [
  SEL_REPLACEMENT_BEHAVIOR_SKILLS,
  SEL_REPLACEMENT_RESILIENCY_SKILLS,
  SEL_REPLACEMENT_SOCIAL_SKILLS_INSTRUCTION
]

function getSELReplacementGoals(contentProfile) {
  switch (contentProfile) {
    case 'florida_no_SEL':
    case 'florida_no_share_no_SEL':
      return SEL_REPLACEMENT_RESILIENCY_SKILLS
    case 'arizona_deervalley_no_SEL':
      return SEL_REPLACEMENT_SOCIAL_SKILLS_INSTRUCTION
    default:
      return SEL_REPLACEMENT_BEHAVIOR_SKILLS
  }
}

const noSelMixin = {
    computed: {
      ...mapGetters({
        selVisibility: ['visibility/selVisibility'],
        profileId: ['contentProfile/profileId'],
      }),
      assessmentSubjectOptionsForProfile() {
        const assessmentSubjectOptionsForProfile = []
        const allSubjectOptions = assessmentsFilterOptions.getSubjectOptions()

        allSubjectOptions.forEach(subjectOption => {
          assessmentSubjectOptionsForProfile.push(new AssessmentFilterOption({
            label: this.getGoalSubjectLabelFromValue(subjectOption.value)
          }))
        })
        return assessmentSubjectOptionsForProfile
      }
    },
    methods: {
        // individual subject/area labels
        getSubjectLabelFromValueByContentType(contentType, subject) {
            const isSelSubject = subject === SEL_DEFAULT_SUBJECT_STRATEGIES_GOALS
            if (!isSelSubject || this.selVisibility) {
                return subject
            }
            switch (contentType) {
                case CONTENT_TYPES.GOAL:
                case CONTENT_TYPES.SAVED_GOAL:
                case CONTENT_TYPES.SUPER_PAGE:
                case CONTENT_TYPES.SAVED_SUPER_PAGE:
                  return getSELReplacementGoals(this.profileId)
                case CONTENT_TYPES.STRATEGY:
                    return SEL_REPLACEMENT_STRATEGIES_PLW
                case CONTENT_TYPES.RESOURCE:
                    return SEL_REPLACEMENT_RESOURCES
                default:
                    return SEL_REPLACEMENT_STRATEGIES_PLW
            }
        },
        getGoalSubjectLabelFromValue(value) {
            return this.getSubjectLabelFromValueByContentType(CONTENT_TYPES.GOAL, value)
        },
        getStrategySubjectLabelFromValue(value) {
            return this.getSubjectLabelFromValueByContentType(CONTENT_TYPES.STRATEGY, value)
        },
        getResourceSubjectLabelFromValue(value) {
            return this.getSubjectLabelFromValueByContentType(CONTENT_TYPES.RESOURCE, value)
        },
        getAssessmentSubjectLabelFromValue(value) {
            return this.getSubjectLabelFromValueByContentType(CONTENT_TYPES.GOAL, value)
        },
        getPlAreaLabelFromValue(value) {
            let subjects = getAreasOfNeed({selBlocked: !this.selVisibility})
            let subject = subjects.find(area => area.value == value)
            return subject.label
        },
        // subject/area label arrays
        getSubjectLabelsFromValuesByContentType(contentType, subjectValues) {
            return subjectValues
            .map(subjectValue => this.getSubjectLabelFromValueByContentType(contentType, subjectValue))
        },
        getResourceSubjectLabelsFromValues(subjectValues) {
            return this.getSubjectLabelsFromValuesByContentType(CONTENT_TYPES.RESOURCE, subjectValues)
        },
        getPlAreaLabelsFromValues(areaValues) {
            return areaValues.map(areaValue => this.getPlAreaLabelFromValue(areaValue))
        },
        assessmentSubjectCategoriesForProfile(subject) {
          let subjectValue = subject
          if (selReplacementSubjects.includes(subjectValue)) {
            subjectValue = SEL_DEFAULT_SUBJECT_STRATEGIES_GOALS
          }
          return assessmentsFilterOptions.getCategoryOptionsFromSubjectValue(subjectValue)
        }
    }
}
